import React, {
  useState,
} from 'react';

import {
  useNavigate,
} from 'react-router-dom';

import { authFetch } from '../utils/authFetch';
import { Card } from '../components/ui';

function requestLocation() {
  return new Promise(
    (resolve, reject) => {
      if (
        typeof navigator === 'undefined' ||
        !navigator.geolocation
      ) {
        reject(
          new Error(
            'La localizzazione non è disponibile su questo dispositivo.'
          )
        );

        return;
      }

      navigator.geolocation.getCurrentPosition(
        resolve,

        () =>
          reject(
            new Error(
              'Devi consentire l’accesso alla posizione nelle impostazioni del dispositivo.'
            )
          ),

        {
          enableHighAccuracy: true,
          timeout: 20000,
          maximumAge: 60000,
        }
      );
    }
  );
}

export default function ConsensoLocalizzazione() {
  const navigate = useNavigate();

  const [busy, setBusy] =
    useState(false);

  const [error, setError] =
    useState('');

  const accetta = async () => {
    setBusy(true);
    setError('');

    try {
      /*
       * Fa comparire anche il consenso del
       * browser/sistema operativo.
       */
      await requestLocation();

      const res = await authFetch(
        '/api/localizzazione/consenso',
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',
          },

          body: JSON.stringify({
            accepted: true,
          }),
        }
      );

      const data =
        await res
          ?.json()
          .catch(() => null);

      if (!res || !res.ok) {
        throw new Error(
          data?.error ||
            'Impossibile salvare il consenso.'
        );
      }

      navigate(
        '/dashboard',
        { replace: true }
      );
    } catch (err) {
      setError(
        err.message ||
          'Errore durante l’attivazione.'
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4 py-8">
      <Card className="w-full max-w-lg p-6 shadow-md">
        <h1 className="text-xl font-semibold text-gray-800">
          Localizzazione per le timbrature
        </h1>

        <p className="mt-3 text-sm text-gray-600">
          Per gestire correttamente le
          timbrature della pausa pranzo,
          l'applicazione utilizza la posizione
          del dispositivo anche quando
          l'applicazione si trova in background,
          nelle finestre temporali necessarie
          alla registrazione automatica.
        </p>

        <div className="mt-4 rounded-xl bg-sky-50 border border-sky-200 p-4 text-sm text-sky-900">
          Se l'inizio pausa non viene registrato
          manualmente, viene inserito
          automaticamente alle{' '}
          <strong>13:00</strong>.

          <br />

          Se la fine pausa non viene registrata
          manualmente, viene inserita
          automaticamente alle{' '}
          <strong>14:00</strong>.

          <br /><br />

          Alla timbratura viene associata la
          posizione rilevata dal dispositivo.
        </div>

        <button
          type="button"
          onClick={() =>
            navigate(
              '/condizioni-consenso-localizzazione'
            )
          }
          className="mt-4 text-sm text-sky-700 underline"
        >
          Condizioni consenso
        </button>

        {error && (
          <div className="mt-4 rounded-lg bg-red-50 border border-red-200 px-3 py-2 text-sm text-red-700">
            {error}
          </div>
        )}

        <button
          type="button"
          disabled={busy}
          onClick={accetta}
          className="mt-6 w-full px-4 py-3 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-semibold disabled:opacity-50"
        >
          {busy
            ? 'Attivazione...'
            : 'Accetta'}
        </button>
      </Card>
    </div>
  );
}